module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAABGdBTUEAALGPC/xhBQAAAQ5JREFUOBFjnDVrVtv///9LGBgYWIGYFPCbkZGxhwWooxjImALEW0jR/e/fP1+QXhag7WxAzWtSU1OPkWIA0OU/gHoLmEjRhE0t48yZM/8DXXAdKPkFmwI8YjxAF2iCwgAEDgENeQRhEkcCNcsBVcINWERGGFgBDUinOAxGDWBgoDgMwOkAmAYEFi1aJEZcCoCo+vnzpwAwLTCADQBmjK3fv38nRT9cLcwFpUBX7IKLQhlMTEyMQMP/o4uD+EDbg4G4DpaUjwFT4iV0hcAcdwAo9igtLS0OXQ6YhwxBYoQC8T6uPAIUvw0yAJQbvwI5G4F4B0iAWAB0vgcQ+7MANU4DMoqAOJJYzVB1/4B6+wC9zGVJDefHjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/Login/images/phone.png
// module id = cyEd
// module chunks = 1